import { useState } from "react";
import { api } from "../lib/events";
import { Link } from "../lib/router";

export function Login({ signedIn = false }: { signedIn?: boolean }) {
  const [busy, setBusy] = useState(false), [error, setError] = useState(""), [visible, setVisible] = useState(false);
  return (
    <section className="login-page">
      <div className="login-card">
        <img className="login-logo" src="/logo.png" alt="On Tap Comedy" />
        <p className="eyebrow">OWNER WORKSPACE</p>
        <h1>Welcome back.</h1>
        <p className="muted">Sign in to manage your shows, artists and lineups.</p>
        {signedIn ? <Link className="button" href="/manage">Go to your shows ↗</Link> : (
          <form onSubmit={async (event) => {
            event.preventDefault();
            const form = event.currentTarget, fields = new FormData(form);
            setBusy(true); setError("");
            try {
              await api("/api/login", "POST", { email: fields.get("email"), password: fields.get("password") });
              form.reset();
              location.replace("/manage");
            } catch (error: any) { setError(error.message); setBusy(false); }
          }}>
            <label>Email<input name="email" type="email" autoComplete="username" placeholder="Your email address" required maxLength={254} disabled={busy} /></label>
            <label htmlFor="owner-password">Password</label>
            <div className="password-field">
              <input id="owner-password" name="password" type={visible ? "text" : "password"} autoComplete="current-password" required maxLength={1024} disabled={busy} />
              <button type="button" className="password-toggle" aria-controls="owner-password" aria-pressed={visible} onClick={() => setVisible(!visible)}>{visible ? "Hide" : "Show"}</button>
            </div>
            <div className="login-error" role="alert">{error}</div>
            <button className="button login-submit" disabled={busy}>{busy ? "Signing in…" : "Sign in"}<span aria-hidden="true">↗</span></button>
          </form>
        )}
        <p className="login-help">Looking to perform? <Link href="/signup">Apply for a show ↗</Link></p>
      </div>
    </section>
  );
}
